import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-client',
	templateUrl:'./ClientPluginPage.html',
	styles: [],
	styleUrls:['./ClientPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class ClientPluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_543 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp</groupId>
  <artifactId>jwebmp-client</artifactId>
</dependency>
\`\`\``;
	mdContent_544 = `\`\`\`kotlin
implementation("com.jwebmp:jwebmp-client:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_545 = `\`\`\`java
public class MyPageConfigurator
        implements IPageConfigurator<MyPageConfigurator> {
    @Override
    public IPage<?> configure(IPage<?> page) {
        // add CSS/JS references, configure body children
        return page;
    }
    @Override
    public Integer sortOrder() { return 500; }
}
\`\`\``;
	mdContent_546 = `\`\`\`java
public class MyPageConfigurator
        implements IPageConfigurator<MyPageConfigurator> {
    @Override
    public IPage<?> configure(IPage<?> page) {
        // add CSS/JS references, configure body children
        return page;
    }
    @Override
    public Integer sortOrder() { return 100; }
}
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
